import { render, staticRenderFns } from "./AccountSettingsForm.vue?vue&type=template&id=282e6710&scoped=true"
import script from "./AccountSettingsForm.vue?vue&type=script&lang=js"
export * from "./AccountSettingsForm.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingsForm.vue?vue&type=style&index=0&id=282e6710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282e6710",
  null
  
)

export default component.exports